module.exports = __webpack_public_path__ + "static/05-846d45c825c620df892ce8b759dd9418.png";